import { updateAnalyticsContext } from '../actions/analyticsContextActions';

// Helper function to map changeType to context key
export const getContextKey = (changeType: string): string => {
  switch (changeType) {
    case 'FILTERS_CHANGED':
      return 'filters';
    case 'METRICS_CHANGED':
      return 'metrics';
    case 'HAVING_FILTERS_CHANGED':
      return 'havingFilters';
    case 'CHART_OPTIONS_CHANGED':
      return 'chartOptions';
    case 'UNDERLYING_METRICS_CHANGED':
      return 'underlyingMetrics';
    case 'REPORT_METADATA_CHANGED':
      return 'reportMetadata';
    case 'REPORT_TYPE_CONFIG_CHANGED':
    case 'REPORT_TYPE_CHANGED':
      return 'config';
    case 'TAB_CHANGED':
      return 'activeTab';
    case 'COMPONENT_MOUNTED':
      // For complete data updates, merge all fields
      return 'completeUpdate';
    case 'CUSTOM_METRICS_CHANGED':
      return 'customMetrics';
    default:
      return 'unknown';
  }
};

export const handleAnalyticsDataChange = (message: any, dispatch: any) => {
  
  // Update the analytics context with the specific change
  let contextUpdate: any = {
    lastUpdated: message.timestamp,
    lastChangeType: message.changeType
  };

  const contextKey = getContextKey(message.changeType);
  
  if (contextKey === 'completeUpdate') {
    // For COMPONENT_MOUNTED, merge all the data
    contextUpdate.completeUpdate = message.data;
  } else if (contextKey !== 'unknown') {
    // For specific updates, update the relevant section
    contextUpdate[contextKey] = message.data;
  }

  
  dispatch(updateAnalyticsContext(contextUpdate));
}; 